import {  addMinutes } from 'date-fns';

// Function to group bookings by date, time range, and booking type
import { formatInTimeZone } from 'date-fns-tz'; 
import { BookingTypeStatus } from '../../../../../platform/util/utils';

export const GroupBookingsByDateAndTimeRange = (bookingsArray, getBookingDetail, answersData, timezone) => {
  const groupedByDate = {};
  const allBookings = Array.isArray(bookingsArray)
    ? bookingsArray.flatMap(({ bookings }) => Array.from(bookings || []))
    : [];
  const parseReferralLeadId = (booking) => {
    const notes = String(booking?.quickNotes || "").trim();
    const match = notes.match(/Referral lead #(\d+)/i);
    return match?.[1] ? String(match[1]).trim() : "";
  };
  const legacyReferralMirrorIds = new Set();
  const latestReferralMirrorByLeadId = new Map();

  allBookings.forEach((booking) => {
    const source = String(booking?.source || "").toLowerCase();
    const isGoogle = source.includes("google");
    if (!isGoogle && Number(booking?.status) === Number(BookingTypeStatus.DELETED)) return;
    if (String(booking?.quickSource || "").trim() !== "referralTour") return;
    const leadId = parseReferralLeadId(booking);
    if (!leadId) return;
    const previous = latestReferralMirrorByLeadId.get(leadId);
    const currentRank = new Date(
      booking?.updatedAt || booking?.createdAt || booking?.time || 0
    ).getTime();
    const previousRank = previous
      ? new Date(
          previous?.updatedAt || previous?.createdAt || previous?.time || 0
        ).getTime()
      : -Infinity;
    if (!previous || currentRank >= previousRank) {
      latestReferralMirrorByLeadId.set(leadId, booking);
    }
  });

  latestReferralMirrorByLeadId.forEach((booking, leadId) => {
    allBookings.forEach((candidate) => {
      if (String(candidate?.quickSource || "").trim() !== "referralTour") return;
      if (parseReferralLeadId(candidate) !== leadId) return;
      if (String(candidate?.id || "") === String(booking?.id || "")) return;
      legacyReferralMirrorIds.add(String(candidate?.id || ""));
    });
  });
  const parseValidDate = (value) => {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  };

  // Loop through bookings to group them
  bookingsArray.forEach(({ date, bookings }) => {
    // Parse the main booking date and convert to Pacific time
    const bookingDate = parseValidDate(date);
    if (!bookingDate) {
      console.error('Invalid booking date:', date);
      return; // Skip if the date is invalid
    }

    // Format the booking date in Pacific time (e.g., "Thursday, April 03 2025")
      const formattedDate = formatInTimeZone(bookingDate, timezone, 'EEEE, MMMM dd yyyy');

    // Initialize the date grouping if it doesn't exist
    if (!groupedByDate[formattedDate]) {
      groupedByDate[formattedDate] = {};
    }

    // Convert bookings set/array to an array
    const bookingsArrayLocal = Array.from(bookings);

    bookingsArrayLocal.forEach((booking) => {
      const source = String(booking?.source || "").toLowerCase();
      const isGoogle = source.includes("google");
      if (!isGoogle && Number(booking?.status) === Number(BookingTypeStatus.DELETED)) {
        return;
      }
      if (legacyReferralMirrorIds.has(String(booking?.id || ""))) {
        return;
      }

      const parentBookingType = getBookingDetail(booking); // Get booking type details
      const bookingTypeTitle =
        booking?.bookingTypeName ||
        booking?.quickTitle ||
        parentBookingType?.title ||
        "Appointment";

      // Validate and parse the booking's time (from UTC)
      const bookingTime = parseValidDate(booking.time);
      if (!bookingTime) {
        console.error('Invalid booking time for booking ID:', booking.id, 'Time:', booking.time);
        return; // Skip if the booking time is invalid
      }

      const bookingLength = Number(booking.duration || 0);

      // Convert and format booking time to Pacific time using formatInTimeZone
        const currentStartTime = formatInTimeZone(bookingTime, timezone, 'hh:mm a'); // e.g., "06:00 pm"
      const currentEndTime = formatInTimeZone(
        addMinutes(bookingTime, bookingLength > 0 ? bookingLength : 30),
          timezone,
        'hh:mm a'
      ); // e.g., "08:00 pm"

      // Create a time range key using the formatted times
      const timeRangeKey = `${currentStartTime} - ${currentEndTime}`;

      // Initialize the time range grouping if it doesn't exist
      if (!groupedByDate[formattedDate][timeRangeKey]) {
        groupedByDate[formattedDate][timeRangeKey] = {};
      }

      // Initialize the booking type grouping if it doesn't exist
      if (!groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle]) {
        groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle] = {
          color: booking.bookingTypeColor,
          count: 0,
          bookings: [],
        };
      }

      // Increment count and add booking details
      groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle].count += 1;
      groupedByDate[formattedDate][timeRangeKey][bookingTypeTitle].bookings.push({
        booking,
        parentBookingType,
        answer: answersData.getBookingAnswers?.find(answer => answer.bookingId === booking.id)?.answer || '',
      });
    });
  });

  return groupedByDate;
};

